<nav class="header" aria-label="main navigation">
  <div class="container">
    <div class="header-menu">
      <a class="mobile-back-button" *ngIf="showBackButton" (click)="goBack()">
        <img class="mobile-back-button-image" [src]="backArrowImageUrl()" />
      </a>

      <a class="header-branding" [routerLink]="['/']">
        <img
          class="header-logo"
          [src]="logoImageUrl()"
          [ngClass]="logoClass()" />
      </a>

      <div class="header-navigation">
        <div class="header-links">
          <div class="first-row">
            <div class="header-icon">
              <a href="#">
                <img
                  class="header-icon-image"
                  [src]="faqIconDesktopImageUrl()" />
              </a>
            </div>
            <div class="header-icon notif-icon">
              <a href="#">
                <img
                  class="header-icon-image"
                  [src]="notifIconWhiteImageUrl()" />
              </a>
            </div>
          </div>

          <div class="second-row">
            <a class="header-link" [routerLink]="['/']">{{
              'app.redemption' | translate
            }}</a>
            <a class="header-link" [routerLink]="['/']">{{
              'app.accrual' | translate
            }}</a>
            <a class="header-link" [routerLink]="['/']">{{
              'app.benefits_and_offers' | translate
            }}</a>
          </div>
        </div>

        <div class="header-dropdown-container">
          <button
            class="toggle-button"
            (click)="toggleDropdown()"
            (rdClickOutside)="closeDropdown()"
            tabindex="0">
            <div class="user-balance-container" tabindex="-1">
              <ng-container [ngSwitch]="getComponentRenderState()">
                <ng-container *ngSwitchCase="'loggedIn'">
                  <div class="user-balance" *ngIf="pointsSummary">
                    <div class="you-have">You have</div>
                    <div class="user-balance-message">
                      <span class="points-balance">{{
                        pointsSummary.pointsBalance | localizeNumber
                      }}</span>
                      <span class="points-currency">{{
                        currencyShortName()
                      }}</span>
                      <img
                        class="dropdown-expander-image"
                        [src]="downWhiteArrowImageUrl()" />
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'loading'">
                  <div class="dropdown-loading-box">
                    <div class="dropdown-loading auth-user-loading"></div>
                    <div class="dropdown-loading auth-points-loading"></div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'loggedOut'">
                  <rd-shared-button
                    class="login-button"
                    [buttonClass]="'login-button'"
                    [buttonContent]="buttonContent"
                    [buttonTheme]="'outline-primary'"
                    (clickFn)="login()">
                    <ng-template #buttonContent>
                      <span class="login-text">{{
                        'header.log_in' | translate
                      }}</span>
                      <img
                        class="login-icon"
                        [src]="loginImageUrl()"
                        alt="Log In" />
                      <img
                        class="login-icon-hover"
                        [src]="loginImageHoverUrl()"
                        alt="Log In" />
                    </ng-template>
                  </rd-shared-button>
                </ng-container>
              </ng-container>
            </div>
          </button>

          <ul class="dropdown" *ngIf="dropdownShown">
            <rd-core-header-dropdown-link
              *ngFor="let navLink of navLinks"
              [navLink]="navLink">
            </rd-core-header-dropdown-link>

            <rd-core-header-dropdown-link
              class="logout"
              (clickEvent)="logout()"
              [navLink]="logoutNavLink">
            </rd-core-header-dropdown-link>
          </ul>
        </div>
      </div>

      <div class="mobile-icons">
        <button
          *ngIf="!showBackButton"
          class="header-icon-button notif-button-mobile">
          <img class="header-icon-image" [src]="notifIconWhiteImageUrl()" />
        </button>

        <rd-core-header-locale-select-mobile
          [locales]="tenantLocales$ | async"
          [localeSelected]="localeSelected$ | async"
          (changeLocale)="
            changeLocale($event)
          "></rd-core-header-locale-select-mobile>
      </div>
    </div>
  </div>
</nav>
